export const TypeShort = () => (
    <div>
        <h5>Los alumnos responderán la pregunta de manera consisa.(80 palabras)</h5>
    </div>
)
